import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LangService {
  private isBrowser: boolean;

  private lang = new BehaviorSubject<string>('en'); // default

  lang$ = this.lang.asObservable();

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);

    // ✅ only access localStorage in browser
    if (this.isBrowser) {
      const savedLang = localStorage.getItem('lang') || 'en';
      this.lang.next(savedLang);

      document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = savedLang;
    }
  }

  setLang(lang: string) {
    this.lang.next(lang);

    if (this.isBrowser) {
      localStorage.setItem('lang', lang);

      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = lang;
    }
  }

  getLang() {
    return this.lang.value;
  }
}
